<template lang="pug">
  .component-create-reporting
    .row.columns
      .row
        fieldset.large-2.columns
          label Status
          select(v-model="body.status")
            option(value="PENDING_REVIEW") Pending Review
            option(value="CONFIRMED") Confirmed
            option(value="RESOLVED") Resolved
            option(value="VOIDED") Voided
        fieldset.large-3.columns
          label Vehicle
          selectize-vehicle(:max-items="1", @optionSelected="vehicleSelected"  :selectedValue="body.vehicle_id")
        fieldset.large-3.columns
          label Type
          select(v-model="body.reporting_type_id", v-on:change="isDamageReport")
            option(v-for="type in reportingTypes", :value="type.id") {{type.name}}


        fieldset.large-3.columns
          label Driver
          selectize-driver(:max-items="1", @optionSelected="driverSelected")
      .row.columns
        label Description
          textarea(v-model="body.description", rows="8")
      .row.columns
        label(aria-describedby='documentsUpload')
          dropzone#myVueDropzone(:url='dropzoneUrl', @vdropzone-success='uploaded')
      .row.columns(v-if="damageReport")
        vehicle-damage(v-if="body.damage_position_raw", :items="body.damage_position_raw", :editable="true", @damagesUpdated="updateDamages", :vehicleDamagePicture="category.damage_picture_external" :vehicleType="vehicleType")
      .row
        .columns.text-center
          label
            input.button.expanded(type='submit', v-on:click="submit")

</template>
<script type="text/babel">
  import Dropzone from 'components/structure/Dropzone'
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import VehicleDamage from '../../components/backoffice/VehicleDamage.vue'
  import SelectizeVehicle from '../../components/structure/ui/lists/selectize/SelectizeVehicle'
  import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'
  import {mapState} from 'vuex'

  export default {
    name: 'BackofficeCreateReporting',
    components: {
      SelectizeDriver,
      SelectizeVehicle,
      VehicleDamage,
      Dropzone
    },
    data() {
      return {
        reportingTypes: [],
        pins: [],
        showVehicleSelect: null,
        body: {
          damage_position_raw: [],
          reporting_type_id: null,
          vehicle_id: null,
          status: null,
          description: null,
          attachments: []
        },
        damageReport: false,
        dropzoneUrl: KeplerBackofficeSdk.getUrlForDropzone(),
        vehicleType: null,
        category: null,
      }
    },
    created() {
      KeplerBackofficeSdk.selects.reportingTypes((data) => {
        this.reportingTypes = data
      })
      if(this.$route.params.vehicleId) {
        this.body.vehicle_id = this.$route.params.vehicleId
      }
    },
    methods: {
      updateDamages(pins) {
        this.body.damage_position_raw = pins
      },
      driverSelected(driver) {
        this.body.driver_id = driver.id
      },
      vehicleSelected(vehicle) {
        this.body.vehicle_id = vehicle.id
        KeplerBackofficeSdk.vehicles.select(vehicle.id).get((data) => {
          this.vehicleType = data.category.vehicle_type.name
          this.category = data.category
        })
      },
      isDamageReport() {
        var damageReportId = this.configuration.application.application_damage_report_id.value
        this.damageReport = this.body.reporting_type_id === damageReportId
      },
      uploaded: function (file, response) {
        this.body.attachments.push(response.token)
      },
      submit() {
        if (this.item) {
          if (this.body.driver_id == '') {
            this.body.driver_id = null
          }

          KeplerBackofficeSdk.reportings.select(this.$route.params.id).edit(this.body, (data) => {
            this.$router.push({name: 'reporting', params: {id: data.id}})
          })
        } else {
          KeplerBackofficeSdk.reportings.make(this.body.vehicle_id, this.body, (data) => {
            this.$router.push({name: 'reporting', params: {id: data.id}})
          })
        }

      }
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      })
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// CreateReporting.vue?727983f4